module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_13-f0158f8ddae4accd45931b98e57bfdc3.png";